import React, { createContext, useEffect, useState } from "react";

// Notifications
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Grommet
import { Grommet, ResponsiveContext } from "grommet";

// Appt router
import PrivateRoute from "./PrivateRoute";

// Appt Components
import Box from "./components/simple/box/Box";

// Appt Screens
import BehaviourDrafts from "./screens/behaviourPlan/BehaviourDrafts";
import BehaviourPlan from "./screens/behaviourPlan/BehaviourPlan";
import BehaviourPlanV2 from "./screens/behaviourPlanV2/BehaviourPlan";


import MyLogin from "./screens/MyLogin";
import Dashboard from "./screens/Dashboard";
import ConcernEdit from "./screens/concernEdit/ConcernEdit";
import IncidentEdit from "./screens/incidentEdit/IncidentEdit";
import IncidentHighLevelEdit from "./screens/incidentHighLevelEdit/IncidentHighLevelEdit";
import IncidentEditCompletion from "./screens/incidentEdit/IncidentEdit-Completion";
import Analytics from './screens/reports/Analytics';

import IncidentDrafts from "./screens/search/incidentSearch/IncidentDrafts";
import IncidentCPOMS from "./screens/search/incidentSearch/IncidentCPOMS";
import IncidentSearch from "./screens/search/incidentSearch/IncidentSearch";
import IncidentSearchGlobal from "./screens/search/incidentSearch/IncidentSearchGlobal";
import AIIncidentTools from "./screens/ai/AIIncidentTools";
import AIIncidentAlpha from "./screens/ai/AIIncidentAlpha";
import AIIncident from "./screens/ai/AIIncident";
import AIStudent from "./screens/ai/AIStudent";
import AIService from "./screens/ai/AIService";
import AILanding from "./screens/ai/AILanding";
import Record from "./screens/Record";
import PDFViewer from "./screens/PDFViewer";

// import BehaviourPlan from './screens/behaviourPlan/BehaviourPlan'
import PasswordReset from "./components/compound/login/PasswordReset";
import LoginScreen from "./screens/Login";
import Logout from "./screens/Logout";
import OrganisationEdit from "./screens/OrganisationEdit";
import OrganisationList from "./screens/OrganisationList";
import RoleEdit from "./screens/RoleEdit";
import RoleList from "./screens/RoleList";
import ServiceSetup from "./screens/ServiceSetup";
import UserActivate from "./screens/User/UserActivate";
import UserProfile from './screens/User/UserProfile';

import UserEdit from "./screens/User/UserEdit";
import UserList from "./screens/User/UserList";
import UserUpload from "./screens/User/UserUpload";
import SmartPlans from "./screens/behaviourPlan/SmartPlans";
import ReportSearch from "./screens/search/reportSearch/ReportSearch";

import ServiceUserList from "./screens/serviceUser/ServiceUserList";
import ServiceUserProfile from "./screens/serviceUser/ServiceUserProfile";
import TermsService from "./services/TermsService";

// Appt Menu
import Sidebar from "./components/compound/sidebar/Sidebar";

// Stores
import { useStore, withStore } from "react-context-hook";

// Services
import LocalStorageService from "./services/LocalStorageService";
import NotificationService from "./services/NotificationService";
import OrganisationService from "./services/OrganisationService";
import PasswordService from "./services/PasswordService";

// Utilities
import { isCurrentOrgAdmin, isGlobalAdmin, isServiceAdmin, isAdmin } from "./utils/permissions";

import './components/chartConfig';

// Theme
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChartPie as falChartPie,
  faRobot as falRobot,
  faClipboard as falClipboard,
  faClipboardListCheck as falClipboardListCheck,
  faCloudUpload as falCloudUpload,
  faCog as falCog,
  faDownload as falDownload,
  faEdit as falEdit,
  faEnvelope as falEnvelope,
  faExclamationCircle as falExclamationCircle,
  faExclamationTriangle as falExclamationTriangle,
  faEye as falEye,
  faFileAlt as falFileAlt,
  faFolderOpen as falFolderOpen,
  faHome as falHome,
  faInfoCircle as falInfoCircle,
  faKey as falKey,
  faMinusCircle as falMinusCircle,
  faPencil as falPencil,
  faPlusCircle as falPlusCircle,
  faPrint as falPrint,
  faQuestionCircle as falQuestionCircle,
  faSave as falSave,
  faSearch as falSearch,
  faTrash as falTrash,
  faUnlink as falUnlink,
  faUser as falUser,
  faUserCircle as falUserCircle,
  faClock as falClock,
  faBolt as falBolt,
  faCheckSquare as falCheckSquare,
  faSquare as falSquare
} from '@fortawesome/pro-light-svg-icons';
import {
  faCog,
  faRobot,
  faExclamationCircle,
  faExclamationTriangle,
  faFile,
  faFilePdf,
  faFolderOpen,
  faUnlink,
  faGavel,
  faGraduationCap,
  faHome,
  faInfoCircle,
  faLink,
  faMusic,
  faNewspaper,
  faPlus,
  faPlusSquare,
  faQuestion,
  faQuestionCircle,
  faSave,
  faThLarge,
  faUpload,
  faUser,
  faUserFriends,
  faVideo,
  faFlag,
  faFlagAlt,
  faClock,
  faThumbsDown,
  faThumbsUp,
  faCheckSquare,
  faSquare
} from '@fortawesome/pro-solid-svg-icons';
import { beSmartTheme } from "./utils/beSmartTheme";

// import "react-chat-elements/dist/main.css"



// Router
import {
  Route,
  BrowserRouter as Router,
  Routes
  // Link
} from "react-router-dom";

// Error logging
import { Provider, ErrorBoundary } from "@rollbar/react";
import ServiceUserNew from "./screens/serviceUser/ServiceUserNew";

const rollbarConfig = {
  accessToken: "657a787429c84629993f3e0926300729",
  captureUncaught: true,
  environment: process.env.NODE_ENV || "development",
  server: {
    branch: "main",
  },
  code_version: "2.2.2",
  captureUnhandledRejections: true,
};

export const GlobalContext = createContext();

function App() {
    library.add(
    falCog,
    falPencil,
    falRobot,
    falInfoCircle,
    falHome,
    falSave,
    falUser,
    falClipboard,
    falClipboardListCheck,
    falFolderOpen,
    falUserCircle,
    falExclamationCircle,
    falExclamationTriangle,
    falSearch,
    falChartPie,
    falPlusCircle,
    falMinusCircle,
    falQuestionCircle,
    falCloudUpload,
    falKey,
    falUnlink,
    falTrash,
    falEdit,
    falEye,
    falFileAlt,
    falDownload,
    falEnvelope,
    faLink,
    falPrint,
    falClock,
    falBolt,
    falSquare,
    falCheckSquare
  );
  library.add(
    faCog,
    faInfoCircle,
    faExclamationCircle,
    faExclamationTriangle,
    faGraduationCap,
    faHome,
    faUnlink,
    faSave,
    faUser,
    faRobot,
    faUserFriends,
    faPlusSquare,
    faQuestion,
    faQuestionCircle,
    faVideo,
    faFolderOpen,
    faMusic,
    faNewspaper,
    faFilePdf,
    faFile,
    faUpload,
    faPlus,
    faThLarge,
    faGavel,
    faFlag,
    faFlagAlt,
    faClock,
    faThumbsUp,
    faThumbsDown,
    faSquare,
    faCheckSquare
  );

  const [apiToken, setApiToken, deleteApiToken] = useStore();
  const [currentUser, setCurrentUser, deleteCurrentUser] = useStore({});
  const [currentOrgs, setCurrentOrgs, deleteCurrentOrgs] = useStore([]);
  const [activeOrg, setActiveOrg, deleteActiveOrg] = useStore({});
  const [terms, setTerms, deleteTerms] = useStore({});

  const [isOrgAdmin, setIsOrgAdmin] = useState(false);

  const [activeOrgState, setActiveOrgState] = useState([]);
  const [myOrganisations, setMyOrganisations] = useState([]);
  const [myPermissions, setMyPermissions] = useState([]);
  const [loginState, setLoginState] = useState({
    loggedInStatus: false,
    apiToken: "",
    userOrganisations: [],
    userDetails: {},
  });

  const refreshOrgData = async () => {
    const activeOrg = LocalStorageService.get("activeOrg");

    if (activeOrg?.id) {
      const response = await OrganisationService.getOrganisation(
        apiToken,
        activeOrg.id
      );
      if (response?.data?.length) {
        let refreshedData = {
          ...activeOrg,
          ...response.data[0],
        };
        if (!response.data[0]?.aiTermsAccepted)
          delete refreshedData.aiTermsAccepted;
        if (!response.data[0]?.enablePILExtras)
          delete refreshedData.enablePILExtras;
        if (!response.data[0]?.wondeSync) delete refreshedData.wondeSync;
        LocalStorageService.set("activeOrg", refreshedData);
        setActiveOrg(refreshedData);
      }
    }
  };

  const checkLoginStatus = () => {
    // If no apiToken in global store get from local storage
    if (!apiToken) {
      const localApiToken = LocalStorageService.get("apiToken");

      if (localApiToken) {
        setApiToken(localApiToken);
        setCurrentOrgs(LocalStorageService.get("userOrganisations"));
        setCurrentUser(LocalStorageService.get("userDetails"));
        setActiveOrg(LocalStorageService.get("activeOrg"));
        setActiveOrgState(LocalStorageService.get("activeOrg"));
        setMyPermissions(LocalStorageService.get("myPermissions"));
        refreshOrgData();
      } else {
        clearSession();
        // window.location.reload()
      }
    }

    // always set the terms
    setTerms(LocalStorageService.get("terms"));

    // If no apiToken in local storage either,
    // clear out the session just in case and
    // force a login
    // if (!apiToken) {
    //   // setApiToken(apiToken)
    //   // get currentOrgs
    //   // const myOrganisations = LocalStorageService.get('currentOrgs')
    //   // setCurrentOrgs(myOrganisations)
    // // } else {
    //   clearSession()
    // }
  };

  // clear the user's session if they log out
  const clearSession = () => {


    // save rememberMe settings
    let rememberMe = LocalStorageService.get("rememberMe");
    let rememberMeCode = LocalStorageService.get("rememberMeCode");
    let rememberMeExpiry = LocalStorageService.get("rememberMeExpiry");

    // remove all localstorage
    LocalStorageService.clear();

    // remove the session data
    deleteApiToken();
    deleteCurrentUser();
    deleteCurrentOrgs();
    deleteActiveOrg();
    deleteTerms();

     // reset rememberMe settings
    if (rememberMe && rememberMeCode) {
      LocalStorageService.set("rememberMe", rememberMe);
      LocalStorageService.set("rememberMeCode", rememberMeCode);
      LocalStorageService.set("rememberMeExpiry", rememberMeExpiry);
    }

  };
  // Get system tags to handle common terms
  const getCommonTerms = async () => {
    const matchedTerms = await TermsService.getCommonTerms();

    LocalStorageService.set("terms", matchedTerms);
    setTerms(matchedTerms);
  };

  const handleLogin = (data) => {
    // Set state
    data.loggedInStatus = true;
    setLoginState(data);

    // And set in local storage & global store
    LocalStorageService.set("apiToken", data.apiToken);
    setApiToken(data.apiToken);
    LocalStorageService.set("userOrganisations", data.userOrganisations);
    setCurrentOrgs(data.userOrganisations);
    LocalStorageService.set("activeOrg", data.userOrganisations?.[0]);
    setActiveOrg(data.userOrganisations?.[0]);
    setActiveOrgState(data.userOrganisations?.[0]);
    LocalStorageService.set("userDetails", data.userDetails);
    setCurrentUser(data.userDetails);

    getCommonTerms(data.apiToken);

    if (data?.rememberMe) {
      LocalStorageService.set("rememberMe", true);
      LocalStorageService.set('rememberMeCode', data.rememberMeCode);
      LocalStorageService.set('rememberMeExpiry', data.rememberMeExpiry);
    }

    // store the permissions for easy access
    var myPermissions = [];
    if (data?.userOrganisations?.[0]?.permissions) {
      myPermissions = data.userOrganisations[0].permissions;
    }
    LocalStorageService.set("myPermissions", myPermissions);
    setMyPermissions(myPermissions);

    // is the org admin me?
    if (data?.userOrganisations?.[0]?.orgAdmin && data?.userDetails?.id) {
      if (
        data.userDetails.id === 1 ||
        data.userDetails.isglobaladmin ||
        data.userDetails.isdeveloper
      ) {
        setIsOrgAdmin(true);
      } else {
        setIsOrgAdmin(data.userOrganisations[0].orgAdmin === data.userDetails.id);
      }
    }
  };

  const handleLogout = () => {
    setLoginState({
      loggedInStatus: false,
      apiToken: "",
      userOrganisations: [],
      userDetails: {},
    });
    clearSession();
  };

  const handlePasswordReset = async (token, data) => {
    try {
      var passwordResetStatus = await PasswordService.resetPassword(
        token,
        data.password
      );

      if (passwordResetStatus.error) {
        NotificationService.error(passwordResetStatus.error);
        return;
      }


    } catch (err) {
      NotificationService.error(err);
    }

    // return

    NotificationService.info("Your password has been reset");

    // history doesn't work in App.js, we'll use this as a test case
    window.location.href = "/login";
  };

  // Set local storage etc with the active organisation
  const selectActiveOrg = (org) => {
    LocalStorageService.set(
      "activeOrg",
      currentOrgs.find((x) => x.id === org)
    );
    setActiveOrg(currentOrgs.find((x) => x.id === org));
    setActiveOrgState(currentOrgs.find((x) => x.id === org));
  };

  // const apiToken = LocalStorageService.get('apiToken')

  // Get Organisation for this User
  const getMyOrganisations = async (apiToken) => {
    if (apiToken) {
      const myOrganisations = await OrganisationService.myOrganisations(
        apiToken
      );

      setMyOrganisations(myOrganisations);
    }
  };

  // Basically componentDidMount
  // useEffect(() => {
  //   getMyOrganisations(apiToken)
  // }, [apiToken])
  useEffect(() => {
    checkLoginStatus();
  }, []);

  useEffect(() => {
    var menuSetup = [];
    const org = LocalStorageService.get("activeOrg");
    const user = LocalStorageService.get("userDetails");

    menuSetup.push({
      linkHref: "/dashboard",
      icon: "home",
      linkTitle: "Dashboard ",
    });

    // Students
    menuSetup.push({
      linkHref: "/record",
      icon: "plus-circle",
      linkTitle: "Record & Plan",
    });

    if (org?.aiTermsAccepted) {
      menuSetup.push({
        linkHref: "/ai/insights",
        icon: "robot",
        linkTitle: "AI Insights",
      });
    }

    // Incidents
    if (isServiceAdmin()) {
      menuSetup.push({
        linkHref: "/incident/search/global",
        icon: "exclamation-circle",
        linkTitle: "Incidents",
      });
    } else {
      menuSetup.push({
        linkHref: "/incident/search",
        icon: "exclamation-circle",
        linkTitle: "Incidents",
      });
    }

    // Plans
    if (org?.plan === "Plus") {
      menuSetup.push({
        linkHref: "/plans",
        icon: "clipboard-list-check",
        linkTitle: "Smart Plans",
      });
    }

    if (isServiceAdmin()) {
      menuSetup.push({
        linkHref: "/analytics",
        icon: "chart-pie",
        linkTitle: "Analytics",
      });
    }

    menuSetup.push({
      linkHref: "/serviceusers",
      icon: "folder-open",
      linkTitle: "Directory",
    });

    // Settings
    if (
      isAdmin() ||
      isServiceAdmin()
    ) {
      menuSetup.push({
        linkHref: "/users",
        icon: "user-circle",
        linkTitle: "System Users",
      });
    }

    if (isAdmin()) {
      menuSetup.push({
        linkHref: "/servicesetup",
        icon: "cog",
        linkTitle: serviceSetupTitle,
      });
    }

    setMenuState(menuSetup);
  }, [activeOrg, myPermissions]);

  const serviceSetupTitle = `${
    terms && terms.service
      ? terms.service?.charAt(0)?.toUpperCase() + terms?.service?.slice(1)
      : "Service"
  } Setup`;

  const [menuState, setMenuState] = useState([]);

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>
        <GlobalContext.Provider value={{ menuState, setMenuState }}>
          <Router>
            <Grommet
              background={{
                color: "background",
                image: "url(/Behaviour-Smart-Background-2.png)",
              }}
              full
              theme={beSmartTheme}
            >
              <ToastContainer position={'top-right'} />

              <ResponsiveContext.Consumer>
                {(size) => {
                  return (
                    <Box
                      className="pageWrapper"
                      align="center"
                      width="100%"
                      height={size !== "xsmall" && size !== "small" ? "100%" : null}
                    >
                      <Box
                        className="pageInnerWrapper"
                        align="center"
                        alignSelf="center"
                        direction="row-responsive"
                        gap="medium"
                        justify="center"
                        margin={{ top: 'small' }}
                        pad={{ horizontal: size }}
                        width="xxlarge"
                      >
                        <Sidebar
                          className="noprint"
                          background="#fff"
                          round="small"
                          width={
                            size === "xsmall" || size === "small" ? "100%" : "medium"
                          }
                          data={menuState}
                          dividerColor="brand"
                          history={history}
                          select={currentOrgs}
                          selected={activeOrgState ? activeOrgState.id : -1}
                          selectActive={selectActiveOrg}
                        />
                        <Routes>
                          <Route
                            terms={terms}
                            path="/pdfviewer"
                            element={<PrivateRoute><PDFViewer /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/search"
                            element={<PrivateRoute><IncidentSearch /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/search/global"
                            element={<PrivateRoute><IncidentSearchGlobal /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/ai/insights"
                            element={<PrivateRoute><AILanding /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/ai/insights/incident"
                            element={<PrivateRoute><AIIncidentTools /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/ai/insights/serviceuser/:userid?"
                            element={<PrivateRoute><AIStudent /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/ai/insights/service"
                            element={<PrivateRoute><AIService /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/ai"
                            element={<PrivateRoute><AIIncidentAlpha /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/aisupport"
                            element={<PrivateRoute><AIIncidentTools /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/drafts"
                            element={<PrivateRoute><IncidentDrafts /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/cpoms"
                            element={<PrivateRoute><IncidentCPOMS /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/plans"
                            element={<PrivateRoute><SmartPlans /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />



                          <Route
                            terms={terms}
                            path="/intervention/analytics"
                            element={<PrivateRoute><Analytics /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/report/search"
                            element={<PrivateRoute><ReportSearch /></PrivateRoute>}
                            submissionType="incidentreport"
                            reportTitle="Global Incident"
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/analytics"
                            element={<PrivateRoute><Analytics /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/behaviour/drafts"
                            element={<PrivateRoute><BehaviourDrafts /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/behaviour/:userid/edit"
                            element={<PrivateRoute><BehaviourPlanV2 /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/behaviour-legacy/:userid/edit"
                            element={<PrivateRoute><BehaviourPlan /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/behaviour-beta/:userid/edit"
                            element={<PrivateRoute><BehaviourPlanV2 /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />



                          <Route
                            terms={terms}
                            path="/log/:userid/edit/:formId?"
                            element={<PrivateRoute><ConcernEdit /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/:userid/ai/:formId"
                            element={<PrivateRoute><AIIncident /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/:userid/edit/:formId?/:status?"
                            element={<PrivateRoute><IncidentEdit /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/incident/high-level/:userid/edit/:formId?/:status?"
                            element={<PrivateRoute><IncidentHighLevelEdit /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/incident/:userid/completion"
                            element={<PrivateRoute><IncidentEditCompletion /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            path="/role/:roleid/edit"
                            element={<PrivateRoute><RoleEdit /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/roles"
                            element={<PrivateRoute><RoleList /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/service/:organisationid/edit"
                            element={<PrivateRoute><OrganisationEdit /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/services"
                            element={<PrivateRoute><OrganisationList /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/user/:userid/edit"
                            element={<PrivateRoute><UserEdit /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            exact
                            path="/user/:userid/profile/:tab?"
                            element={<PrivateRoute><UserProfile /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/serviceuser/new/upload"
                            element={<PrivateRoute><UserUpload type="serviceuser" /></PrivateRoute>}
                            activeOrg={activeOrgState}
                            type="serviceuser"
                          />

                          <Route
                            terms={terms}
                            path="/serviceuser/new/edit"
                            element={<PrivateRoute><ServiceUserNew /></PrivateRoute>}
                            activeOrg={activeOrgState}
                            type="serviceuser"
                          />

                          <Route
                            terms={terms}
                            path="/user/new/upload"
                            element={<PrivateRoute><UserUpload type="user" /></PrivateRoute>}
                            activeOrg={activeOrgState}
                            type="user"
                          />
                          <Route
                            terms={terms}
                            path="/users"
                            element={<PrivateRoute><UserList /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/servicesetup"
                            element={<PrivateRoute><ServiceSetup /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/serviceuser/:userid/:view/:tab?"
                            element={<PrivateRoute><ServiceUserProfile /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/serviceusers/:filter?/:by?"
                            element={<PrivateRoute><ServiceUserList /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />



                          <Route
                            terms={terms}
                            path="/record/:id?"
                            element={<PrivateRoute><Record /></PrivateRoute>}
                            activeOrg={activeOrgState}
                          />

                          <Route
                            terms={terms}
                            path="/dashboard"
                            element={<PrivateRoute><Dashboard /></PrivateRoute>}
                            loggedInStatus={loginState}
                            activeOrg={activeOrgState}
                          />
                          <Route
                            terms={terms}
                            path="/"
                            element={<PrivateRoute><Dashboard /></PrivateRoute>}
                            loggedInStatus={loginState}
                            activeOrg={activeOrgState}
                          />


                          <Route
                            path="/mylogin"
                            element={(props) => (
                              <MyLogin {...props} handleLogin={handleLogin} />
                            )}
                          />

                          <Route path="/user/activate" element={<UserActivate />} />
                          <Route
                            path="/logout"
                            element={
                              <Logout
                                handleLogout={handleLogout}
                                loggedInStatus={loginState}
                              />
                            }
                          />
                          <Route
                            path="/login"
                            element={
                              <LoginScreen
                                handleLogin={handleLogin}
                                handleLogout={handleLogout}
                                loggedInStatus={loginState}
                              />
                            }
                          />
                          <Route
                            path="/reset-password"
                            element={
                              <PasswordReset
                                handlePasswordReset={handlePasswordReset}
                              />
                            }
                          />
                          <Route
                            element={() => (
                              <h1>404: page not found - to be created</h1>
                            )}
                          />
                        </Routes>
                      </Box>
                    </Box>
                  );
                }}
              </ResponsiveContext.Consumer>
            </Grommet>
          </Router>
        </GlobalContext.Provider>
      </ErrorBoundary>
    </Provider>
  );
}

export default withStore(App);
